import Vue from 'vue'
import VueRouter from 'vue-router'

import { FbMember } from '../constants'

import Home from '../views/Home'
import FbMemberList from '../views/FbMemberList'
import FbProfile from '../views/FbProfile'
import FbPage from '../views/FbPage'
import FbGroup from '../views/FbGroup'
import FbRandoms from '../views/FbRandoms'
import FbStatusList from '../views/FbStatusList'
import FbStatus from '../views/FbStatus'
import FbStatusContent from '../views/FbStatusContent'
import FbComments from '../views/FbComments'
import WebPages from '../views/WebPages'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/fb-profiles',
    component: FbMemberList,
    props: { type: FbMember.Profile }
  },
  {
    path: '/fb-profiles/:id',
    component: FbProfile
  },
  {
    path: '/fb-pages',
    component: FbMemberList,
    props: { type: FbMember.Page }
  },
  {
    path: '/fb-pages/:id',
    component: FbPage
  },
  {
    path: '/fb-groups',
    component: FbMemberList,
    props: { type: FbMember.Group }
  },
  {
    path: '/fb-groups/:id',
    component: FbGroup
  },
  {
    path: '/fb-randoms',
    component: FbRandoms
  },
  {
    path: '/fb-posts',
    component: FbStatusList
  },
  {
    path: '/fb-posts/:id',
    component: FbStatus
  },
  {
    path: '/fb-posts/:id/content',
    component: FbStatusContent
  },
  {
    path: '/fb-posts/:id/comments',
    component: FbComments
  },
  {
    path: '/web-pages',
    component: WebPages
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }  
})

export default router
